// Third-party
import React from 'react';
import moment from 'moment';

// Components
import DatesDisclaimer from './DatesDisclaimer';
import DetailedDatesDisclaimer from './DetailedDatesDisclaimer';

// Utils
import { getAllocationsAsAtDates, getDetailedAllocationsAsAtDates } from '../../../../utils/disclaimers/comparison';
import { formatMessageWithLocale, FormattedMessage } from '../../../../utils/i18n';
import { getLatestDates } from '../../../../utils/comparison';
import ComparisonItem from '@/types/comparison-item';
import Locale from '@/types/locale';

interface Props {
  items: ComparisonItem[];
  shorthand?: boolean;
  showItemNames?: boolean;
  locale?: Locale;
  detailed?: boolean;
}

const getDisclaimerDate = (items: ComparisonItem[], locale?: Locale) => {
  const { allocations } = getLatestDates(items);
  return allocations ? moment.utc(allocations).format(formatMessageWithLocale('Common.DateFormats.Short', locale)) : undefined;
};

const AssetAllocationDisclaimer = ({ items, shorthand, showItemNames, locale, detailed }: Props) => {
  if (shorthand) {
    const date = getDisclaimerDate(items);
    if (!date) {
      return null;
    }

    return (
      <span className="disclaimer dates-disclaimer">
        <FormattedMessage id="Disclaimers.ShortAllocations" values={{ date: getDisclaimerDate(items, locale) }} locale={locale} />
      </span>
    );
  }

  if (detailed) {
    return (
      <DetailedDatesDisclaimer
        globalPrefix={formatMessageWithLocale('Disclaimers.Allocations', locale)}
        itemPrefix={formatMessageWithLocale('Disclaimers.AsAt', locale)}
        itemDates={getDetailedAllocationsAsAtDates(items, locale)}
        showItemNames={showItemNames}
        locale={locale}
      />
    );
  }

  return (
    <DatesDisclaimer
      globalPrefix={formatMessageWithLocale('Disclaimers.Allocations', locale)}
      itemPrefix={formatMessageWithLocale('Disclaimers.AsAt', locale)}
      itemDates={getAllocationsAsAtDates(items, locale)}
      showItemNames={showItemNames}
      locale={locale}
    />
  );
};

export default AssetAllocationDisclaimer;
